import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteMemberAttendance = ({ attendanceId }) => {
  return api.delete(`/admin/member-attendance/${attendanceId}`);
};

export const useDeleteMemberAttendanceMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteMemberAttendance,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
